import React, { useRef, useState, useEffect } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import '../../styles/DigitalSignature.css';
import { FormattedMessage, useIntl } from 'react-intl';
import ButtonComponent from '../ButtonComponent';
import Toast from "../../helpers/Toast";
import { useMobile, useTablet } from '../Layout/UseResponsive';

interface SignatureProps {
  onSave: (dataUrl: string) => void;
  onCancel: () => void;
}

const DigitalSignature: React.FC<SignatureProps> = ({ onSave, onCancel }) => {
  const signatureRef = useRef<SignatureCanvas>(null);
  const [isOrientationCorrect, setIsOrientationCorrect] = useState(true);
  const intl = useIntl();

  const isMobile = useMobile();
  const isTablet = useTablet();

  // Definir tamanhos de canvas dependendo ecrã
  const canvasWidth = isMobile ? 500 : isTablet ? window.innerWidth * 0.7 : window.innerWidth * 0.5;
  const canvasHeight = isMobile ? 150 : isTablet ? window.innerHeight * 0.4 : window.innerHeight * 0.3;

  const handleSave = () => {
    if (signatureRef.current && !signatureRef.current.isEmpty()) {
      const dataUrl = signatureRef.current.toDataURL();
      onSave(dataUrl);
      onCancel();
    } else if (signatureRef.current && signatureRef.current.isEmpty()) {
      Toast.Show("error", intl.formatMessage({ id: "DigitalSignature.Empty" }));
    }
  };

  useEffect(() => {
    if (isMobile || isTablet) {
      const mediaQuery = window.matchMedia('(orientation: landscape)');

      const handleOrientationChange = (event: MediaQueryListEvent) => {
        setIsOrientationCorrect(event.matches);
      };

      mediaQuery.addEventListener('change', handleOrientationChange);
      setIsOrientationCorrect(mediaQuery.matches);

      return () => {
        mediaQuery.removeEventListener('change', handleOrientationChange);
      };
    }
  }, [isMobile, isTablet]);

  useEffect(() => {
    if (!isOrientationCorrect) {
      Toast.Show("info", intl.formatMessage({ id: "DigitalSignature.Orientation" }));
    }
  }, [isOrientationCorrect]);

  return (
    <div className="signature-container">
      {isOrientationCorrect && (
        <div className="signature-popup">
          <SignatureCanvas ref={signatureRef} canvasProps={{ width: canvasWidth, height: canvasHeight }} />
          <div className="buttons-container">
            <ButtonComponent onClick={onCancel} text={intl.formatMessage({ id: "DigitalSignature.Cancel" })} className="cancel-button" />
            <ButtonComponent onClick={handleSave} text={intl.formatMessage({ id: "DigitalSignature.Save" })} className="save-button" />
          </div>
        </div>
      )}
    </div>
  );
};

export default DigitalSignature;
